<template>
	<v-card>
		<v-list>
			<v-subheader>Концепции</v-subheader>
			<v-list-item-group :value="currentConcept">
				<v-list-item
					v-for="concept in concepts"
					:key="concept"
					:value="concept"
					@click="changePageConcept(concept)"
				>
					<v-list-item-content>
						<v-list-item-title v-text="concept" align="left"></v-list-item-title>
					</v-list-item-content>
					<v-list-item-action>
						<v-tooltip bottom>
							<template v-slot:activator="{ on }">
								<v-btn icon small @click="deleteConcept(concept)" v-on="on">
									<v-icon small>mdi-delete</v-icon>
								</v-btn>
							</template>
							<span>Удалить концепцию</span>
						</v-tooltip>
					</v-list-item-action>
				</v-list-item>
			</v-list-item-group>
		</v-list>
		<v-divider></v-divider>
		<v-card-actions class="justify-center">
			<v-tooltip bottom>
				<template v-slot:activator="{ on }">
					<v-btn
						text
						color="success"
						@click="saveDialog.dialog = true"
						:disabled="!isNotSaved"
						v-on="on"
					>
						<v-icon left>mdi-content-save</v-icon>
					</v-btn>
				</template>
				<span>Сохранить</span>
			</v-tooltip>
			<v-tooltip bottom>
				<template v-slot:activator="{ on }">
					<v-btn
						text
						color="info"
						@click="projectPage"
						v-on="on"
					>
						<v-icon left>mdi-newspaper-plus</v-icon>
					</v-btn>
				</template>
				<span>Добавить новую концепцию</span>
			</v-tooltip>
		</v-card-actions>
	</v-card>
</template>

<script>
  export default {
    name: "ListConceptComponent",
    props: {
      saveConcept: Function,
      concepts: Array,
      changePage: Function,
      saveDialog: Object,
      isNotSaved: Boolean,
      deleteConcept: Function,
    },
    methods: {
      changePageConcept: function (concept) {
        this.changePage({
          name: 'ProjectPageConcept',
          params: {name: this.$route.params.name, concept: concept}
        })
      },
      projectPage: function () {
        this.changePage({
          name: 'ProjectPage',
          params: {name: this.$route.params.name}
        })
      }
    },
    computed: {
      currentConcept: function () {
        return this.$route.params.concept
      }
    },
  }
</script>